document.addEventListener("DOMContentLoaded", function () {
  const plusButtons = document.querySelectorAll(".js-plus");
  const minusButtons = document.querySelectorAll(".js-minus");
  const totalCountEl = document.querySelector(".total-count");
  const mobTotalCountEl = document.querySelector(".mob-total-count");
  const summaryContainer = document.querySelector(".bundle-product-list product-mm-list > div");
  const discountText = document.querySelector(".text-percentage-wrap span");
  const discountInfo = document.querySelector(".text-percentage-wrap p");
  const addToCartBtn = document.querySelector(".nws-submit-btn span");
  const progressBars = document.querySelectorAll(".bundle-step");
  const steps = document.querySelectorAll("[data-bundel-step]");

  let totalItems = 0;
  let totalPrice = 0;

  // UPDATED BETTER LOGIN CHECK FUNCTION
  function isCustomerLoggedIn() {
    // Method 1: ShopifyAnalytics (most reliable)
    if (typeof ShopifyAnalytics !== 'undefined' && 
        ShopifyAnalytics.meta && 
        ShopifyAnalytics.meta.page && 
        ShopifyAnalytics.meta.page.customerId !== undefined && 
        ShopifyAnalytics.meta.page.customerId !== null) {
      return true;
    }

    // Method 2: __st.cid (old reliable)
    if (typeof __st !== 'undefined' && __st.cid) {
      return true;
    }

    // Method 3: Meta tag
    if (document.querySelector('meta[name="customer"]')) {
      return true;
    }

    // Method 4: Body classes
    if (document.body.classList.contains('template-customers-account') || 
        document.body.classList.contains('customer-logged-in')) {
      return true;
    }

    // Method 5: Global window.customer
    if (typeof window.customer !== 'undefined' && window.customer !== null) {
      return true;
    }

    return false;
  }

  function updateSummaryAndDiscount() {
    totalItems = 0;
    totalPrice = 0;
    const selectedItems = [];

    document.querySelectorAll(".bundle-product-list .summary-item").forEach(el => el.remove());

    document.querySelectorAll(".product-card").forEach(card => {
      const input = card.querySelector("input.reset");
      const qty = parseInt(input.value) || 0;
      const minusBtn = card.querySelector(".js-minus");

      if (qty > 0) {
        minusBtn.style.display = "inline-flex";
        input.style.width = "50px";
        input.style.textAlign = "center";
      } else {
        minusBtn.style.display = "none";
        input.style.width = "40px";
      }

      if (qty > 0) {
        totalItems += qty;

        const title = card.querySelector(".mix-bundle-title").textContent.trim();
        const priceText = card.querySelector(".price-quantity-wrap p").textContent;
        const price = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.'));
        const imageSrc = card.querySelector(".prd-media img").src;

        totalPrice += price * qty;

        const itemHTML = `
          <div class="list-image-content summary-item" data-variant-id="${card.dataset.variantId}">
            <img src="${imageSrc}" loading="lazy" width="80" height="80" alt="${title}">
            <div class="js-step-number">
              <p>
                <strong>${title}</strong><br>
                ${qty} × ${price.toFixed(2)} €
              </p>
              <div class="summary-qty-controls" style="margin-top:8px;display:flex;align-items:center;">
                <button class="reset js-minus-summary" style="width:32px;height:32px;font-size:18px;">−</button>
                <input type="text" class="reset summary-input" value="${qty}" style="width:40px;text-align:center;">
                <button class="reset js-plus-summary" style="width:32px;height:32px;font-size:18px;">+</button>
              </div>
            </p>
            </div>
          </div>
        `;

        selectedItems.push(itemHTML);
      }
    });

    if (selectedItems.length > 0) {
      summaryContainer.innerHTML = selectedItems.join("") + summaryContainer.innerHTML;
    }

    totalCountEl.textContent = totalItems;
    if (mobTotalCountEl) mobTotalCountEl.textContent = totalItems;

    steps.forEach(step => {
      const required = parseInt(step.dataset.bundelStep);
      if (totalItems >= required) step.classList.remove("hidden");
      else step.classList.add("hidden");
    });

    progressBars.forEach((bar, index) => {
      if (totalItems > index) bar.classList.add("active");
      else bar.classList.remove("active");
    });

    let discount = 0;
    if (totalItems >= 4) discount = 15;
    else if (totalItems === 3) discount = 10;
    else if (totalItems === 2) discount = 5;

    const savings = totalPrice * (discount / 100);
    const finalPrice = totalPrice - savings;

    if (discountText) discountText.innerHTML = `<strong>-${discount}%</strong>`;
    if (totalItems >= 2) {
      discountInfo.innerHTML = `You're saving <strong>${discount}%</strong> on your pack!`;
    } else {
      discountInfo.innerHTML = `Add at least 2 products to <strong>get :</strong>`;
    }

    if (totalItems === 0) {
      addToCartBtn.innerHTML = "ADD 1 PRODUCT";
    } else if (discount > 0) {
      addToCartBtn.innerHTML = `
        <strong>ADD TO CART – ${finalPrice.toFixed(2)}€</strong>
        <span style="text-decoration:line-through; opacity:0.7; margin-left:8px; font-size:14px;">
          ${totalPrice.toFixed(2)}€
        </span>
      `;
    } else {
      addToCartBtn.innerHTML = `<strong>ADD TO CART – ${totalPrice.toFixed(2)}€</strong>`;
    }

    bindSummaryControls();
  }

  function bindSummaryControls() {
    document.querySelectorAll(".js-plus-summary").forEach(btn => {
      btn.onclick = function () {
        const summaryItem = this.closest(".summary-item");
        const variantId = summaryItem.dataset.variantId;
        const mainCard = document.querySelector(`.product-card[data-variant-id="${variantId}"]`);
        const mainPlus = mainCard.querySelector(".js-plus");
        mainPlus.click();
      };
    });

    document.querySelectorAll(".js-minus-summary").forEach(btn => {
      btn.onclick = function () {
        const summaryItem = this.closest(".summary-item");
        const variantId = summaryItem.dataset.variantId;
        const mainCard = document.querySelector(`.product-card[data-variant-id="${variantId}"]`);
        const mainMinus = mainCard.querySelector(".js-minus");
        if (parseInt(mainCard.querySelector("input.reset").value) > 0) {
          mainMinus.click();
        }
      };
    });
  }

  // PLUS BUTTON – WITH UPDATED LOGIN CHECK
  plusButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      if (!isCustomerLoggedIn()) {
        alert("Please log in to build your pack");
        return;
      }

      const input = btn.parentElement.querySelector("input.reset");
      let currentValue = parseInt(input.value) || 0;

      if (currentValue === 0) {
        input.value = 10;
      } else {
        input.value = currentValue + 1;
      }

      updateSummaryAndDiscount();
    });
  });

  // MINUS BUTTON – WITH UPDATED LOGIN CHECK
  minusButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      if (!isCustomerLoggedIn()) {
        alert("Please log in to build your pack");
        return;
      }

      const input = btn.parentElement.querySelector("input.reset");
      let val = parseInt(input.value) || 0;

      if (val > 10) {
        input.value = val - 1;
      } else if (val > 0) {
        input.value = 0;
      }

      updateSummaryAndDiscount();
    });
  });

  // ADD TO CART
  document.querySelector(".nws-submit-btn").addEventListener("click", function (e) {
    e.preventDefault();

    const itemsToAdd = [];
    document.querySelectorAll(".product-card").forEach(card => {
      const qty = parseInt(card.querySelector("input.reset").value) || 0;
      if (qty > 0) {
        itemsToAdd.push({
          id: card.dataset.variantId,
          quantity: qty,
          properties: {
            '_bundle': 'Mix & Match Pack',
            '_discount_applied': totalItems >= 2 ? 'Yes' : 'No'
          }
        });
      }
    });

    if (itemsToAdd.length === 0) return;

    this.classList.add("loading");
    this.querySelector("span").textContent = "Adding...";

    const cartDrawer = document.querySelector('cart-drawer');
    const shouldFlushPendingCartDrawerWork =
      cartDrawer &&
      typeof cartDrawer.flushAllPendingNow === 'function' &&
      ((typeof cartDrawer.hasPendingCartMutations === 'function' && cartDrawer.hasPendingCartMutations()) ||
        (typeof cartDrawer.hasPendingGroupedWork === 'function' && cartDrawer.hasPendingGroupedWork()) ||
        (cartDrawer._pendingMutations && cartDrawer._pendingMutations.size));
    const preflight = shouldFlushPendingCartDrawerWork
      ? cartDrawer.flushAllPendingNow().catch(() => {})
      : Promise.resolve();

    preflight.then(() => fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd })
    }))
    .then(() => {
      window.location = "/checkout";
    })
    .catch(() => {
      alert("Error! Try again.");
      this.classList.remove("loading");
      updateSummaryAndDiscount();
    });
  });

  // Initial load
  updateSummaryAndDiscount();
});